module.exports = __webpack_public_path__ + "static/media/instagram_black.7a2b6bb4.svg";